/**
 *  CategoryList widget JS
 */

(function() {
  var elements = document.getElementsByClassName('playmakers-category-list');

  for (var i = 0; i < elements.length; i++) {
    var topElement = elements[i];
    var firstRowContainer = topElement.querySelector('.row > div');
    var arrowRight = topElement.querySelector('.category-widget-scroll-right');
    var arrowLeft = topElement.querySelector('.category-widget-scroll-left');
    let elementWidth = firstRowContainer.offsetWidth;

    var scrollState = 0;

    // Scroll handle function
    var handleScroll = function(event) {
      var targetElement = event.target || event.srcElement;
      var direction = targetElement.getAttribute('scroll');
      var topElement = targetElement.closest('.playmakers-category-list');
      var rowContainer = topElement.querySelector('.row');
      var arrowLeft = topElement.querySelector('.category-widget-scroll-left');
      var fadeLeft = topElement.querySelector('.more-pages.left');

      if (direction == 'right') {
        scrollState += elementWidth;
      } else {
        scrollState -= elementWidth;
      }

      rowContainer.scrollLeft = scrollState;
      scrollState = rowContainer.scrollLeft;

      // Only shown scroll left if we have done any right scrolling
      if (scrollState > 0) {
        arrowLeft.style.display = 'block';
        fadeLeft.style.display = 'block';
      } else {
        arrowLeft.style.display = 'none';
        fadeLeft.style.display = 'none';
      }
    };

    if (arrowRight) {
      arrowRight.addEventListener('click', handleScroll, false);
    }
    if (arrowLeft) {
      arrowLeft.addEventListener('click', handleScroll, false);
    }
  }
})();
